export default __webpack_public_path__ + "static/media/filter_gif.a4064282.svg";